export const sellerDetailView = (adId: number) =>
    `/transaksjonsoversikt/salg/transaksjon/${adId}`;

export const buyerDetailView = (transactionId: string) =>
    `/transaksjonsoversikt/kjop/transaksjon/${transactionId}`;
